import useFlags from 'components/shared/useFlags'
import { useAuth } from 'services/auth'
/**
 * Custom hook to check if the current organization has XGBoost classifier access
 * Uses an allowlist approach: organizations must be explicitly enabled or 'all' specified
 * @returns boolean indicating if XGBoost features should be enabled
 */
export const useXGBoostAccess = (): boolean => {
  const { user } = useAuth()
  const { xgboostEnabledOrganizations } = useFlags()

  // If no user or no org_id, deny access
  if (!user || !user.org_id) {
    return false
  }

  // If the flag is empty, no organizations have access
  if (!xgboostEnabledOrganizations || xgboostEnabledOrganizations.trim() === '') {
    return false
  }

  // If 'all' is in the list, enable for everyone
  if (xgboostEnabledOrganizations.toLowerCase().includes('all')) {
    return true
  }

  // Check if the user's org_id is in the enabled list
  const enabledOrgs = xgboostEnabledOrganizations
    .split(',')
    .map(org => org.trim())
    .filter(org => org.length > 0)

  return enabledOrgs.includes(user.org_id)
}

export default useXGBoostAccess
